import { z } from 'zod';
import { filteredJoin } from '@/modules/location/domain/filteredJoin.ts';
import { join } from 'lodash-es';

export const AddressSchema = z.object({
    country: z.string(),
    state: z.string(),
    city: z.string(),
    street: z.string().nullable(),
    streetNumber: z.string().nullable(),
    zipCode: z.string(),
});
export type Address = z.infer<typeof AddressSchema>;

export const formatAddress = (address: Address) => {
    const streetAndNumber = address.street ? filteredJoin([address.street, address.streetNumber], ' ') : '';
    const zipCodeAndCity = join([address.zipCode, address.city], ' ');

    return filteredJoin([streetAndNumber, zipCodeAndCity, address.country], ', ');
};
